import { LABELS } from '@/constants/common/message.constants'
import { type Unpacked } from '@/utils/type-utils'

import { type TruckSpecificationEntity } from '../..'

/**
 * 車両装備 (特殊1)
 */
export type FirstTruckEquipmentType = Unpacked<
  Exclude<TruckSpecificationEntity['firstEquipments'], null>
>

export const FIRST_TRUCK_EQUIPMENT_TYPE = {
  /** 冷凍 */
  FREEZER: 'FREEZER',
  /** 冷蔵 */
  REFRIGERATED: 'REFRIGERATED',
  /** 保冷 */
  INSULATED: 'INSULATED',
  /** ダンプ */
  DUMP: 'DUMP',
  /** ヘッド */
  TRACTOR_HEAD: 'TRACTOR_HEAD',
  /** 海上コンテナ (20ft) */
  MARITIME_CONTAINER_20FT: 'MARITIME_CONTAINER_20FT',
  /** 海上コンテナ (40ft) */
  MARITIME_CONTAINER_40FT: 'MARITIME_CONTAINER_40FT',
  /** 鉄道コンテナ */
  RAILWAY_CONTAINER: 'RAILWAY_CONTAINER',
  /** 花車 */
  FLOWER_TRUCK: 'FLOWER_TRUCK',
  /** ハンガー */
  HANGER_TRUCK: 'HANGER_TRUCK'
} as const satisfies Record<FirstTruckEquipmentType, FirstTruckEquipmentType>

export const FIRST_TRUCK_EQUIPMENT_TYPE_LABEL = {
  [FIRST_TRUCK_EQUIPMENT_TYPE.FREEZER]: LABELS.FREEZER,
  [FIRST_TRUCK_EQUIPMENT_TYPE.REFRIGERATED]: LABELS.REFRIGERATED,
  [FIRST_TRUCK_EQUIPMENT_TYPE.INSULATED]: LABELS.INSULATED,
  [FIRST_TRUCK_EQUIPMENT_TYPE.DUMP]: LABELS.DUMP,
  [FIRST_TRUCK_EQUIPMENT_TYPE.TRACTOR_HEAD]: LABELS.TRACTOR_HEAD,
  [FIRST_TRUCK_EQUIPMENT_TYPE.MARITIME_CONTAINER_20FT]:
    LABELS.MARITIME_CONTAINER_20FT,
  [FIRST_TRUCK_EQUIPMENT_TYPE.MARITIME_CONTAINER_40FT]:
    LABELS.MARITIME_CONTAINER_40FT,
  [FIRST_TRUCK_EQUIPMENT_TYPE.RAILWAY_CONTAINER]: LABELS.RAILWAY_CONTAINER,
  [FIRST_TRUCK_EQUIPMENT_TYPE.FLOWER_TRUCK]: LABELS.FLOWER_TRUCK,
  [FIRST_TRUCK_EQUIPMENT_TYPE.HANGER_TRUCK]: LABELS.HANGER_TRUCK
} as const satisfies Record<FirstTruckEquipmentType, string>
